@use './nhs-core.scss' as *;
@use './nhs-button.scss' as *;

.timeout-overlay {
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 99998;
}

.timeout-modal {
  box-sizing: border-box;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 99999;
  width: 500px;
  max-width: 90%;
  padding: 32px;
  transform: translate(-50%, -50%);
  background-color: #ffffff;
  border-radius: 0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  color: #212b32;
  font-size: 16px;
  line-height: 24px;
  outline: none;
}

.timeout-modal__heading {
  margin: 0 0 16px;
  font-size: 24px;
  font-weight: 600;
  line-height: 28px;
}

.timeout-modal__body {
  margin-bottom: 24px;
}

.timeout-modal__body p {
  margin: 0;
  font-size: 16px;
  line-height: 24px;
}

.timeout-modal__buttons {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
}

.timeout-modal__link {
  padding: 0;
  border: 0;
  background: transparent;
  color: #005eb8;
  font: inherit;
  text-decoration: underline;
  cursor: pointer;
}

.timeout-modal__link:hover {
  color: #003d7a;
}

.timeout-modal__link:focus-visible {
  outline: 4px solid #ffeb3b;
  outline-offset: 1px;
  color: #212b32;
  background-color: #ffeb3b;
  text-decoration: none;
}

@media (max-width: 640px) {
  .timeout-modal {
    width: calc(100% - 32px);
    padding: 24px;
  }

  .timeout-modal__buttons .nhsuk-button {
    width: 100%;
  }
}
